var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui segment" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui segment" },
      [
        _c("div", { staticClass: "ui top left attached label" }, [
          _vm._v("Climates")
        ]),
        _vm._v(" "),
        _vm._l(_vm.climates, function(climate, index) {
          return _c("div", { key: index }, [
            _vm._v("\n\t\t\t" + _vm._s(climate) + "\n\t\t")
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui segment" },
      [
        _c("div", { staticClass: "ui top left attached label" }, [
          _vm._v("Geologies")
        ]),
        _vm._v(" "),
        _vm._l(_vm.geologies, function(geology, index) {
          return _c("div", { key: index }, [
            _vm._v("\n\t\t\t" + _vm._s(geology) + "\n\t\t")
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "globe icon" }),
      _vm._v(" Climate and geology :")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }